import React from 'react';
import { PageTitle } from '@cordata/buffet';

import NotesForm from '~/components/Note/Form';

const NotesAdd = () => (
  <>
    <PageTitle>Add Note</PageTitle>

    <NotesForm />
  </>
);

export default NotesAdd;
